import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Box from '@/components/UI/box/Box';
import carouselSetting from '@/components/home/mostVisited/_constants/carouselSettings';
import mostVisitedCities from '@/components/home/mostVisited/_constants/mostVisitedCities';
import styles from '@/components/home/mostVisited/MostVisited.module.scss';
import Carousel from '@/components/reusable/carousel/Carousel';
import { SplideSlide } from '@splidejs/react-splide';
import heap from '@/helpers/heap';
const MostVisitedCarousel = () => {
  const handleHeapEvent = cityName => {
    heap.track('city_carousel_click', {
      city_name: cityName
    });
  };
  return <Carousel opts={carouselSetting} data-sentry-element="Carousel" data-sentry-component="MostVisitedCarousel" data-sentry-source-file="MostVisitedCarousel.tsx">
      {mostVisitedCities.map((city, index) => <SplideSlide key={`city-item-${index}`} className={`${styles['city-splide-item']}`}>
          <Link prefetch={false} href={`/search/city/${city?.hrefName || city?.name}`} className={styles['styles-cityItem']} onClick={() => handleHeapEvent(city?.name)}>
            <Box component={'figure'} className={styles['image-wrapper']}>
              <Image src={city?.absolute_photo_url} alt={city?.name} layout="fill" objectFit="fill" loading={'lazy'} />
              <Box component={'figcaption'} className={styles['city-details']}>
                {city?.name}
              </Box>
            </Box>
          </Link>
        </SplideSlide>)}
    </Carousel>;
};
export default MostVisitedCarousel;